module.exports = __webpack_public_path__ + "img/gift2.4f798d70.png";